import { requestToken, requestTokenImage } from "./request_method";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/agency`;

class AgencyProfileService {
  // AGENCY DATA
  async agencyProfile(formData) {
    try {
      let action = API_ROUTE + "/agency-profile";
      const response = await requestTokenImage.post(action, formData);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
}

export default AgencyProfileService;
